import { BrainCircuit } from 'lucide-react'
import MemoryStoreSummary from './MemoryStoreSummary'
import type { MemoryBankStats, MemoryCopy } from './types'

interface Props {
  copy: MemoryCopy
  total: number
  visibleCount: number
  truncated: boolean
  loading: boolean
  stats?: MemoryBankStats
}

export default function MemoryAliveHeader({ copy, total, visibleCount, truncated, loading, stats }: Props) {
  const numberFormat = new Intl.NumberFormat('pt-BR')
  const connected = truncated
    ? copy.recent_sample.replace('%{shown}', numberFormat.format(visibleCount)).replace('%{total}', numberFormat.format(total))
    : copy.connected.replace('%{count}', numberFormat.format(total))

  return (
    <header data-testid="memory-alive-header" className="relative z-20 flex h-16 items-center gap-3 border-b border-border bg-card px-4 py-3 sm:px-5 lg:col-start-1 lg:row-start-1">
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-primary/10 text-primary">
        <BrainCircuit className="h-4.5 w-4.5" />
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2">
          <h2 className="truncate text-base font-semibold tracking-tight text-foreground">{copy.alive_title}</h2>
          {loading && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary" />}
        </div>
        <p className="truncate text-[11px] text-faint-foreground">{connected}</p>
      </div>
      {stats && <MemoryStoreSummary copy={copy} stats={stats} />}
    </header>
  )
}
